<template>
    <v-card class="d-flex flex-column folders-tree-card" flat min-height="380" tile width="350">
        <div class="grow scroll-x">
            <v-treeview
                v-if="items"
                ref="tree"
                :active="active"
                :items="items"
                :load-children="readFolderHash"
                :open="open"
                :search="filter"
                activatable
                class="folders-tree"
                dense
                item-key="path"
                item-text="basename"
                open-all
                transition
                v-on:update:active="activeChanged"
            >
                <template v-slot:prepend="{ item, open }">
                    <v-icon
                        v-if="item.type === 'dir'"
                    >
                        {{ open ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
                    </v-icon>
                    <v-icon v-else>{{ icons[item.extension.toLowerCase()] || icons['other'] }}</v-icon>
                </template>
                <template v-slot:label="{ item }">
                    <span
                        @drop.prevent="onDrop($event, item.path)"
                        @dragenter="onDragEnter"
                        @dragleave="onDragLeave"
                        @dragover.prevent
                        :class="{ 'font-weight-bold': item.fileCount}"
                    >
                        {{ item.basename }}
                    </span>
                    <v-btn
                        v-if="item.type === 'dir'"
                        class="ml-1"
                        icon
                        @click.stop="readFolderHash(item)"
                    >
                        <v-icon class="pa-0 mdi-18px" color="grey lighten-1">mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-treeview>
        </div>
        <v-divider></v-divider>
        <v-toolbar class="shrink" dense flat>
            <v-text-field
                v-model="filter"
                class="ml-n3"
                flat
                hide-details
                label="Filter"
                prepend-inner-icon="mdi-filter-outline"
                solo
            ></v-text-field>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click="init" v-on="on">
                        <v-icon>mdi-collapse-all-outline</v-icon>
                    </v-btn>
                </template>
                <span>Alle einklappen</span>
            </v-tooltip>
        </v-toolbar>
    </v-card>
</template>

<script>
export default {
    props: {
        icons: Object,
        storage: String,
        path: String,
        hash: String,
        endpoints: Object,
        axios: Function,
        refreshPending: Boolean,
        student: Number,
        initialDirectory: String,
        typeOf: String
    },
    data() {
        return {
            open: [1],
            active: [],
            items: [],
            filter: "",
            treeview: null
        };
    },
    methods: {
        async getFolderStructure() {
            let result = null;

            //result = await this.axios.get(`/api/student-files/${this.student}?api_token=3yDrMg9GmY8dApiT`)
            let url = this.endpoints.list.url
                .replace(new RegExp("{student_id}", "g"), this.student);

            let config = {
                url,
                method: "get"
            };

            result = await this.axios.request(config);

            let capTyp = this.typeOf.charAt(0).toUpperCase() + this.typeOf.slice(1);

            let basename = `${capTyp}_${this.student}`

            const directories = [
                {
                    type: "dir",
                    path: "/",
                    basename: basename,
                    extension: "",
                    name: "root",
                    children: []
                }
            ];

            result.data.data.directories.map(item => {
                directories[0].children.push({
                    type: "dir",
                    path: "/" + item.path,
                    basename: item.name,
                    extension: "",
                    name: item.path,
                    hash: btoa(item.path),
                    fileCount: item.fileCount,
                })
            })

            return directories
        },
        async init() {
            this.open = [];
            this.items = [];

            // set default files tree items (root item) in nextTick.
            // Otherwise, this.open isn't cleared properly (due to syncing perhaps)
            const folders = await this.getFolderStructure()
            this.treeview = this.$refs.tree;

            this.items = folders;
            this.active.push('/');

            if (this.path !== "") {
                this.$emit("path-changed", "");
            }
        },
        async openSubFolder() {
            setTimeout(() => {
                const path = `/Student_${this.student}/${this.initialDirectory}`;
                this.activeChanged([path])
            }, 400)
        },
        onDrop(e, path) {
            if (path === '/') {
                e.currentTarget.parentElement.parentElement.classList.remove('upload-drop-area');
                return;
            }
            this.activeChanged([path]);
            this.$emit("add-files", e.dataTransfer.files);
            e.currentTarget.parentElement.parentElement.classList.remove('upload-drop-area');
        },

        onDragEnter(e) {
            e.currentTarget.parentElement.parentElement.classList.add('upload-drop-area');
        },

        onDragLeave(e) {
            e.currentTarget.parentElement.parentElement.classList.remove('upload-drop-area');
        },

        async readFolderHash(item) {
            const hash = btoa(item.path.replace('/', ''))

            this.$emit("loading", true);

            let url = this.endpoints.listHash.url
                .replace(new RegExp("{storage}", "g"), this.storage)
                .replace(new RegExp("{path}", "g"), item.path)
                .replace(new RegExp("{hash}", "g"), hash)

            let config = {
                url,
                method: this.endpoints.listHash.method || "get",
                charset: 'utf-8',
                responseEncodig: 'utf-8'
            };

            let response = await this.axios.request(config);

            // eslint-disable-next-line require-atomic-updates
            /*
            item.children = response.data.data.directories.map(item => {
                if (item.type === "dir") {
                    item.children = [];
                }
                return item;
            });
            */
            const dirs = response.data.data.directories

            if (dirs.length) {
                item.children = dirs.map(item => {
                    return {
                        type: "dir",
                        path: "/" + item.path,
                        basename: item.name,
                        extension: "",
                        name: item.path,
                        hash: btoa(item.path)
                        // children: []
                    }
                })
            } else {
                item.children = [];
            }

            // item.children = response.data.data.directories;


            this.$emit("loading", false);
        },
        activeChanged(active) {
            this.active = active;
            let path = "";
            // get new stucture
            if (active.length) {
                path = active[0];
            }
            this.readFolderHash({hash: this.hash, path: path})

            if (this.path !== path) {
                this.$emit("path-changed", path);
            }
        },
        findItem(path) {
            let stack = [];
            stack.push(this.items[0]);

            while (stack.length > 0) {
                let node = stack.pop();

                if (node.path === path) {
                    return node;
                } else if (node.children && node.children.length) {
                    for (let i = 0; i < node.children.length; i++) {
                        stack.push(node.children[i]);
                    }
                }
            }
            return null;
        },
    },
    watch: {
        storage() {
            this.init();
        },
        path() {
            this.active = [this.path];

            if (!this.open.includes(this.path)) {
                this.open.push(this.path);
            }
        },
        async refreshPending() {
            if (this.refreshPending) {
                let item = this.findItem(this.path);
                await this.readFolderHash(item);
                this.$emit("refreshed");
            }
        }
    },
    beforeMount() {
        this.init();
        this.openSubFolder();
    }
};
</script>

<style lang="scss" scoped>
.folders-tree-card {
    height: 100%;

    .scroll-x {
        overflow-x: auto;
    }

    ::v-deep .folders-tree {
        width: fit-content;
        min-width: 250px;

        .v-treeview-node {
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.02);
            }
        }
    }
}

::v-deep .upload-drop-area {
    background-color: #90caf9 !important;
}
</style>
